import React, { Fragment } from "react";
import { Formik, Form } from "formik";

import { DateField } from "./form";
import { MondayToFridayCalendar, DateHelper } from "../../common/src";
import { useQueryState, useQueryStateLazy } from "./use-query-state";

export function defaultDate(): Date {
    const cal = new MondayToFridayCalendar();
    let d = DateHelper.addDays(new Date(), -1);
    while (!cal.isBusinessDay(d)) {
        d = DateHelper.addDays(d, -1);
    }
    return d;
}

type DateFormPropsType = {
    defaultDateString: string;
    dateName?: string;
    className?: string;
    minDate?: string;
    label?: string;
    /** When true, do not write default to URL until user changes the date (keeps URL clean) */
    lazyUrl?: boolean;
};

export const DateForm = ({
    defaultDateString,
    dateName = "endDate",
    className = "",
    minDate,
    label = "",
    lazyUrl = false
}: DateFormPropsType): React.ReactElement => {
    const useHook = lazyUrl ? useQueryStateLazy : useQueryState;
    const [date, setDate] = useHook(dateName, defaultDateString);
    const formData: any = {};
    formData[dateName] = date;

    return (
        <Formik
            enableReinitialize={true}
            initialValues={formData}
            validate={(validateFormData) => {
                const errors: any = {};
                const date = validateFormData[dateName];
                const isValid = typeof date === "string" && (date === "" || /^\d{4}-\d{2}-\d{2}$/.test(date));
                if (date !== formData[dateName] && isValid) {
                    setDate(date);
                }
                return Object.keys(errors).length > 0 ? errors : {};
            }}
            onSubmit={(_values) => {
                // Empty function since we don't need form submission
            }}
        >
            {({ isSubmitting }) => (
                <Fragment>
                    <Form autoComplete="off">
                        <div className={"form" + (className ? " " + className : "")}>
                            <DateField
                                className=""
                                name={dateName}
                                label={
                                    label
                                        ? label
                                        : dateName
                                              .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
                                              .replace(/^./, (c) => c.toUpperCase()) // Capitalize the first letter
                                              .replace(/ (\w)/g, (c) => c.toLowerCase()) // Ensure spaces followed by lowercase
                                }
                                disabled={isSubmitting}
                                minDate={minDate}
                            />
                        </div>
                    </Form>
                </Fragment>
            )}
        </Formik>
    );
};
